import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { CanActivateGuard } from './shared/guards/can-activate.guard';

const routes: Routes = [
  // Stage 5 hotfix (2026-05-21): bare-domain and unknown routes land on the
  // Cognito sign-in page directly. Previously redirected to "auth" which
  // defaults to the legacy LoginComponent, which still calls
  // oauthService.initLoginFlow() -> auth.dev.medmio.com (Duende). The
  // resulting Duende JWT is rejected by the API (DuendeEnabled=false in
  // SSM since Stage 5), breaking sign-in. Full LoginComponent + OAuthService
  // cleanup is Sprint 10 (Duende decom) scope.
  { path: "", pathMatch: "full", redirectTo: "auth/sign-in" },
  {
    path: "auth",
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "main",
    canLoad: [CanActivateGuard],
    canActivate: [CanActivateGuard],
    loadChildren: () => import("./main/main.module").then((m) => m.MainModule),
  },
  { path: "**", redirectTo: "auth/sign-in" },
  // {
  //   path: "",
  //   component: MainLayoutComponent,
  //   children: [],
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
